import { useMutation, useQueryClient } from 'react-query';

import { queryKeys, requests } from 'RestAPIs/rapini';

import { showSuccessSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';

/**
 * The generated delete hook binds the schedule id when the hook is created, but the grid only knows
 * which row to delete when it is clicked. So this wraps the generated request instead.
 */
export const useDeleteOpeningSchedule = (planUnitId: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    (openingScheduleId: string) =>
      requests.deleteOpeningSchedule(planUnitId, openingScheduleId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.getOpeningSchedules.name);
        queryClient.invalidateQueries(queryKeys.getEffectiveOpeningHours.name);
        showSuccessSnackbar();
      },
      onError: showError
    }
  );
};
